// extracted by mini-css-extract-plugin
module.exports = {"container":"shared-components-Routing-Routing__container--1ov56","mainContent":"shared-components-Routing-Routing__mainContent--399bh"};